<template>
  <b-modal
    id="modal-prevent-closing"
    ref="modal"
    title="Notification"
    :ok-only="true"
    :hide-header-close="true"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true ? true : false"
    :visible="notification.isVisible"
    size="md"
  >
    <p class="notification__header">{{ notification.header }}</p>
    <div class="notification__body" @click="push_to_external">
      {{ notification.body }}
    </div>
    <template v-slot:modal-footer>
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="sm" variant="secondary" @click="clear_notification">
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
// import CryptoJS from 'crypto-js'

export default {
  data() {
    return {
      passphrase: ''
    }
  },
  methods: {
    ...mapActions(['clear_notification']),
    handleSubmit() {
      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing')
      })
    },
    push_to_external: function() {
      window.location.href = `https://ropsten.etherscan.io/tx/${this.notification.body}`
    }
  },
  computed: {
    ...mapState(['notification'])
  }
}
</script>

<style>
* {
}

.notification__body {
  word-wrap: break-word;
  cursor: pointer;
}

.notification__header {
  font-weight: 600;
  font-size: 20px;
}
</style>
